import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { adminLogin } from "../../Apis/index";
import { IMAGES } from "../../assets/img/ImageIndex";
import "../../assets/css/admin.css";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const from = location.state?.from?.pathname || "/admin/dashboard";
      navigate(from);
    }
  }, [navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await adminLogin(formData);
      localStorage.setItem("token", res?.data?.data?.token);
      if (res?.data?.data?.token) {
        const from = location.state?.from?.pathname || "/admin/dashboard";
        navigate(from);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-form">
        <div className="admin-login-logo">
          <img
            src={IMAGES.logo}
            alt="Ridge Crest Logo"
          />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-login-form-group">
            <label
              htmlFor="email"
              className="admin-login-label"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              name="email"
              className="admin-login-input"
              placeholder="Enter your email"
              required
              onChange={(e) =>
                setFormData({
                  ...formData,
                  email: e.target.value,
                })
              }
              value={formData.email}
            />
          </div>
          <div className="admin-login-form-group">
            <label
              htmlFor="password"
              className="admin-login-label"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              className="admin-login-input"
              placeholder="Enter your password"
              required
              autoComplete="current-password"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  password: e.target.value,
                })
              }
              value={formData.password}
            />
          </div>
          <div className="admin-login-checkbox-group">
            <label className="admin-login-checkbox-label">
              <input
                id="remember_me"
                type="checkbox"
                name="remember"
                className="admin-login-checkbox"
              />
              <span className="admin-login-checkbox-text">Remember me</span>
            </label>
            <Link
              to="/forgot-password"
              className="admin-login-forgot-link"
            >
              Forgot your password?
            </Link>
          </div>
          <button
            type="submit"
            className="admin-login-submit-btn"
          >
            Log in
          </button>
        </form>
      </div>
    </div>
  );
}
